import React, { useState,useEffect } from "react";
import QueryTable from "../components/Query/Query";
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { API, Auth} from 'aws-amplify';

const QuerySearch = (props) => {

	// const [ userInfo , setUserInfo ] = useState(false)
	const [ newSearches , setNewSearches ] = useState(0)	
	const [navLink, setNavLink] = useState('');
	
	let [searchParams, setSearchParams] = useSearchParams();

	let project_id = searchParams.get("projectid");
	let project_type = searchParams.get("projecttype");

	const handleOnSearch = (report_id) => {
		setNavLink(`/queryserachreports?id=${report_id}&create=true`)
		// checkUser(props.user)
		setNewSearches(newSearches+1)
	};

    // const checkUser = async(user) => {
    //     const token = user.signInUserSession.idToken.jwtToken
    //     const credentials = await Auth.currentUserCredentials();
    //     const requestInfo = { headers: { Authorization: token } }
    //     console.log('checkUser')
    //     API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
    //     .then(response => {
    //         console.log(response)
    //         // setUserInfo(response)
    //         localStorage.setItem('query_searches', response.query_searches)
    //         localStorage.setItem('entity_searches', response.entity_searches)
    //         localStorage.setItem('keyword_searches', response.keyword_searches)
    //         localStorage.setItem('user_type', response.user_type)
    //     })
    //     .then(error => {
    //         console.log(error)
    //     })
    //     return 0
    // }
    // useEffect(() => {checkUser(props.user)}, [])
   
	return (
		<Container>
			<h3>{console.log(newSearches)}</h3>
			{
			<QueryTable project_id={project_id} project_type={project_type} onSearch={handleOnSearch} />
			}
			<div style={{"display":"flex"}}>
				<NavLink to={navLink}>
					<Button variant="primary">Create Report</Button>{' '}
				</NavLink>
			</div>
		</Container>
	);
};

export default QuerySearch;